module.exports = __webpack_public_path__ + "static/media/image_comment.836b39fd.svg";